export default "__VITE_ASSET__e9b1dc88__"